// var moment = require('moment-timezone');
// import dayjs from 'dayjs'
// import 'dayjs/locale/en'
// import utc from 'dayjs/plugin/utc'

// dayjs.extend(utc)
// dayjs.locale('en')

let locale = process.env.VUE_APP_I18N_LOCALE;
let tz = locale === 'zh_CN' ? 'Asia/Shanghai' : 'America/Chicago';

const formatDate = (date, formatStr, isForce) => {
  if (!date) return '';
  let defaultFormat = locale === 'zh_CN' ? 'MM/DD/YYYY' : 'MM/DD/YYYY';
  let tz = locale === 'zh_CN' ? 'Asia/Shanghai' : 'America/Chicago';
  let format = isForce ? formatStr : `${formatStr || defaultFormat}`;

  // 纯日期字符串 (YYYY-MM-DD) 用 UTC 解析，不做时区转换，避免日期偏移
  if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
    return window.moment.utc(date).format(format);
  }

  return window.moment(date).tz(tz).format(format);
};

// 转换为浏览器本地时间, 年月日时分秒
export const formatDateTime = (timestamp) => {
  if (!timestamp) return '';
  const date = new Date(timestamp);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

// wait time format, parameter: seconds
const formatIdleTime = (second) => {
  second = Math.trunc(second);
  // greater than one day
  if (second > 3600 * 24) {
    const day = parseInt(second / (3600 * 24));
    const hour = parseInt((second % (3600 * 24)) / 3600);
    return `${day}d ${hour}h`;
  } else if (second > 3600) {
    // greater than one hour
    const hour = parseInt(second / 3600);
    const minute = parseInt((second % 3600) / 60);
    return `${hour}h ${minute}m`;
  } else if (second > 60) {
    // greater than one minute
    const minute = parseInt(second / 60);
    const s = parseInt(second % 60);
    return `${minute}m ${s}s`;
  } else {
    // less than one minute
    return `${second}s`;
  }
};

const createDate = (date) => {
  return window.moment(date).tz('America/Chicago');
};

const dateFormatted = (date, split) => {
  if (!split) return;
  if (split === '-') {
    const [year, month, day] = date.split(split);
    return `${month}/${day}/${year}`;
  } else {
    const [month, day, year] = date.split(split);
    return `${year}-${month}-${day}`;
  }
};

// seconds to time
const formatSecond = (second) => {
  if (second <= 0) {
    return '';
  }
  let hour = Math.floor(second / 3600);
  let minute = Math.floor((second % 3600) / 60);
  let sec = second % 60;
  let time = '';
  if (hour) {
    time += `${hour}h `;
  }
  if (minute) {
    time += `${minute}m`;
  }
  if (!hour) {
    time += ` ${sec}s`;
  }
  return time;
};

// get month start date and end date
const getMonthDate = () => {
  const start = window.moment().tz(tz).startOf('month').format('YYYY-MM-DD');
  const end = window.moment().tz(tz).format('YYYY-MM-DD');
  return [start, end];
};

export const getUTCMonthDate = () => {
  const start = window.moment().utc().startOf('month').format('YYYY-MM-DD');
  const end = window.moment().utc().format('YYYY-MM-DD');
  return [start, end];
};

export const getUTCTodayDate = () => {
  const start = window.moment().utc().startOf('day').format('YYYY-MM-DD');
  const end = window.moment().utc().format('YYYY-MM-DD');
  return [start, end];
};

// get some days ago date
export function getDaysAgoDateString(days = 0) {
  return window.moment().tz(tz).subtract(days, 'days').format('YYYY-MM-DD');
}

// get some days after date
export function getDaysAfterDateString(days = 0) {
  return window.moment().tz(tz).add(days, 'days').format('YYYY-MM-DD');
}

// get local time
export function getLocalTime(format = 'YYYY-MM-DD HH:mm:ss') {
  return window.moment().format(format);
}

export function getNow(format = 'YYYY-MM-DD') {
  return window.moment().tz(tz).format(format);
}

// get last count months
export function getMonthList(count = 12) {
  let monthList = [];
  for (let i = 0; i < count; i++) {
    monthList.push(window.moment().tz(tz).subtract(i, 'months').format('YYYY-MM'));
  }
  return monthList;
}

// get last count years
export function getYearList(count = 5) {
  let yearList = [];
  for (let i = 0; i < count; i++) {
    yearList.push(window.moment().tz(tz).subtract(i, 'years').format('YYYY'));
  }
  return yearList;
}

export { formatDate, createDate, dateFormatted, formatIdleTime, formatSecond, getMonthDate };
// export default dayjs
